// minimal floating tooltip for the multi-day map renderer, independent of
// route colour (accessibility: colour can't be the only info carrier)
export type TooltipController = {
  show: (html: string, clientX: number, clientY: number) => void;
  hide: () => void;
  destroy: () => void;
};

export const createTooltipController = (): TooltipController => {
  const el = document.createElement("div");
  el.style.cssText = `
    position: fixed;
    z-index: 10000;
    pointer-events: none;
    background: rgba(20, 24, 28, 0.92);
    color: #fff;
    font-size: 12px;
    line-height: 1.5;
    padding: 6px 10px;
    border-radius: 6px;
    max-width: 220px;
    display: none;
    transform: translate(14px, 14px);
  `;
  document.body.appendChild(el);

  const position = (x: number, y: number) => {
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;
  };

  return {
    show(html, x, y) {
      el.innerHTML = html;
      position(x, y);
      el.style.display = "block";
    },
    hide() {
      el.style.display = "none";
    },
    destroy() {
      el.remove();
    },
  };
};
